import {ElementRef, Directive, HostListener} from '@angular/core';
@Directive({
    selector: '[parentRemove]'
})
export class ParentRemoveDirective {
    alert_parent: any;
    constructor(private elements: ElementRef) {}

    @HostListener('click', ['$event'])
    onToggle($event: any) {
        $event.preventDefault();
        this.alert_parent = (this.elements).nativeElement.parentElement;
        this.alert_parent.remove();
    }
}



// WEBPACK FOOTER //
// D:/Angular projects/memberreg/memberreg/src/app/shared/elements/parent-remove.directive.ts